import React from "react";
import { useTranslation } from "react-i18next";

export function LanguageToggle() {
  const { i18n, t } = useTranslation();
  const current = i18n.language?.startsWith("en") ? "en" : "zh";

  const setLang = (lng) => {
    if (lng === current) return;
    i18n.changeLanguage(lng);
    try {
      localStorage.setItem("poseidon_lang", lng);
    } catch {}
  };

  return (
    <div
      role="group"
      aria-label={t("hud.language")}
      className="glass rounded-full flex items-center p-1 text-[13px] font-mono-brand select-none"
      data-testid="language-toggle"
    >
      <button
        type="button"
        onClick={() => setLang("zh")}
        aria-pressed={current === "zh"}
        data-testid="language-toggle-zh-button"
        className={[
          "relative px-3.5 py-1.5 rounded-full transition-colors duration-300 outline-none focus-visible:ring-2 focus-visible:ring-[var(--gold-400)]",
          current === "zh"
            ? "text-[var(--navy-950)] bg-[var(--gold-400)]"
            : "text-[var(--paper-50)]/80 hover:text-[var(--paper-50)]",
        ].join(" ")}
      >
        中
      </button>
      <button
        type="button"
        onClick={() => setLang("en")}
        aria-pressed={current === "en"}
        data-testid="language-toggle-en-button"
        className={[
          "relative px-3.5 py-1.5 rounded-full transition-colors duration-300 outline-none focus-visible:ring-2 focus-visible:ring-[var(--gold-400)]",
          current === "en"
            ? "text-[var(--navy-950)] bg-[var(--gold-400)]"
            : "text-[var(--paper-50)]/80 hover:text-[var(--paper-50)]",
        ].join(" ")}
      >
        EN
      </button>
    </div>
  );
}
